<template>
  <b-nav-item-dropdown
    :text="dropDownText"
    right
  >
    <b-dropdown-item
      v-if="!isLoggedIn"
      :to="{name: 'login'}"
    >
      {{ $t('login.title') }}
    </b-dropdown-item>
    <b-dropdown-item
      v-if="!isLoggedIn"
      :to="{name: 'register'}"
    >
      {{ $t('register.title') }}
    </b-dropdown-item>
    <b-dropdown-item
      v-if="isLoggedIn"
      @click="signOut()"
    >
      Logout
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { Auth } from "aws-amplify";
export default {
  name: "NavbarUserDropDown",
  data: function() {
    return {
      email: ""
    };
  },
  computed: {
    dropDownText: function() {
      if (!this.$store.state.signedIn) {
        return this.$t("login.title");
      }
      return this.email;
    },
    isLoggedIn: function() {
      return this.$store.state.signedIn;
    },
    currentUser: function() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    signOut: function() {
      Auth.signOut()
        .then(data => {
          console.log(data);
        })
        .catch(err => console.log(err));
    }
  },
  watch: {
    currentUser: function(newCurrentUser) {
      if (newCurrentUser) {
        var self = this;
        newCurrentUser.getUserAttributes(function(err, result) {
          if (err) {
            console.log(
              "getUserAttributesResult error: ",
              err.message || JSON.stringify(err)
            );
            return "";
          }
          for (let i = 0; i < result.length; i++) {
            if (result[i].getName() == "email") {
              console.log("yoyoyo");
              self.email = result[i].getValue();
            }
          }
        });
      }
    }
  }
};
</script>

<style>
</style>